"use client";

import clsx from "clsx";
import GailIcon from "@/components/common/GailIcon";
import Icon from "@/components/library/Icon";
import {getModelIcon, getModelIconType} from "@/utils/ai/assistants";
import {isAutoAssistantModel} from "@/utils/ai/modelCatalog";

export default function ModelMark({
   model,
   className,
}: Readonly<{
   model: string;
   className?: string;
}>) {
   if (isAutoAssistantModel(model)) {
      return (
         <GailIcon
            width={12}
            height={12}
            className={clsx("size-3 shrink-0 opacity-60", className)}
         />
      );
   }

   return (
      <Icon
         icon={getModelIcon(model)}
         type={getModelIconType(model)}
         className={clsx("text-[10px] opacity-60 shrink-0", className)}
      />
   );
}
